import { useState, useContext, memo, FC, useEffect } from 'react';
import { css } from '@emotion/react';
import { Grid, Form, Segment } from 'semantic-ui-react';
import { Link, useHistory } from 'react-router-dom';
import { CognitoUser } from 'amazon-cognito-identity-js';

import { Context } from '../../../context/ContextProvider';
import { CognitoLogin, CognitoSendMfaCode } from '../../../Repository/Cognito';
import DefaultButton from '../../Atoms/button/DefaultButton';
import AuthForm from '../../Atoms/Form/AuthForm';
import AuthText from '../../Atoms/auth/AuthText';
import AuthTitle from '../../Atoms/auth/AuthTitle';
import ErrorMassage from '../../Atoms/ErrorMessage';
import Loading from '../../Atoms/Loading';
import { URL } from '../../../util';

const LoginForm: FC = memo(() => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | undefined>('');
  const [isloading, setIsLoading] = useState(false);
  const [mfaUser, setMfaUser] = useState<CognitoUser | undefined>();
  const [mfaCode, setMfaCode] = useState('');
  const {
    setIdToken,
    setIsLogin,
    setAccessToken,
    isLogin,
    setUserName,
    setTenantAlias,
  } = useContext(Context);
  const history = useHistory();
  const loginHandle = () => {
    setIsLoading(true);
    CognitoLogin({
      email,
      password,
      setAccessToken,
      setIdToken,
      setErr,
      setIsLogin,
      history,
      setUserName,
      userName: email,
      setTenantAlias,
      setMfaUser,
    });

    if (isLogin === false) {
      setEmail('');
      setPassword('');
    }
    setIsLoading(false);
  };
  const mfaHandle = () => {
    if (!mfaUser) {
      return;
    }
    CognitoSendMfaCode({
      cognitoUser: mfaUser,
      code: mfaCode.trim(),
      setAccessToken,
      setIdToken,
      setErr,
      setIsLogin,
      history,
      setUserName,
      userName: email,
      setTenantAlias,
      setMfaUser,
    });
    setMfaCode('');
  };
  const backToLogin = () => {
    setMfaUser(undefined);
    setMfaCode('');
    setErr('');
  };
  useEffect(() => {
    document.title = 'GrantDrive | お客様ポータルログイン';
  }, []);

  return (
    <Grid.Column textAlign="justified">
      <Form css={segmentPosition} size="mini">
        <Segment size="large">
          <AuthTitle title="お客様ポータルログイン" />
          {err && <ErrorMassage errMessage={err} />}
          {mfaUser ? (
            <>
              <AuthText marginTp="30px" marginBt="0px">
                認証アプリに表示されている6桁のコードを入力してください。
              </AuthText>
              <AuthForm
                label="認証アプリのコード"
                value={mfaCode}
                setValue={setMfaCode}
                maxLength={6}
              />
              <DefaultButton
                text="認証"
                marginTp="50px"
                onClinckFunc={mfaHandle}
                disabled={mfaCode.trim() === ''}
              />
              <AuthText marginBt="50px" marginTp="10px" border>
                <span
                  role="button"
                  tabIndex={0}
                  css={linkStyle}
                  onClick={backToLogin}
                  onKeyPress={backToLogin}
                >
                  ログイン画面に戻る
                </span>
              </AuthText>
            </>
          ) : (
            <>
              <AuthForm label="Email" value={email} setValue={setEmail} />
              <AuthForm
                label="パスワード"
                value={password}
                setValue={setPassword}
                password
              />
              {isloading && <Loading />}
              {!isloading && (
                <DefaultButton
                  text="ログイン"
                  marginTp="50px"
                  onClinckFunc={loginHandle}
                  disabled={isloading}
                />
              )}
              <Link to={URL.passwordReset} css={aStyle}>
                <AuthText marginBt="50px" marginTp="10px" border>
                  パスワードを忘れた方はこちら
                </AuthText>
              </Link>
            </>
          )}
        </Segment>
      </Form>
    </Grid.Column>
  );
});

const segmentPosition = css({
  marginTop: '50px',
});
const aStyle = css({
  color: 'black',
});
const linkStyle = css({
  cursor: 'pointer',
});

export default LoginForm;
